import type React from "react";

import { SWReactIcons } from "@similarweb/icons";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { StyledTooltip } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/components/WithTitleContainer/styles";

type Props = {
    title: string;
    withMargin?: boolean;
    tooltip?: string;
    dataAutomation?: string;
    additionalContent?: React.ReactNode;
};

export const WithTitleContainer: React.FC<React.PropsWithChildren<Props>> = ({
    title,
    children,
    tooltip,
    dataAutomation,
    withMargin = true,
    additionalContent,
}) => {
    return (
        <Box
            margin={withMargin ? "0 0 36px 0" : "0"}
            data-automation={dataAutomation}
        >
            <Flex
                alignItems="center"
                gap="4px"
                margin="0 0 12px 0"
            >
                <Text
                    fontVariant="body1"
                    display="block"
                >
                    {translate(title)}
                </Text>
                {tooltip ? (
                    <StyledTooltip content={tooltip}>
                        <SWReactIcons
                            iconName="info"
                            size="xs"
                        />
                    </StyledTooltip>
                ) : null}
                {additionalContent ?? null}
            </Flex>
            {children}
        </Box>
    );
};
